/* eslint-disable import/no-anonymous-default-export*/
import { CLEAR_ERROR, GET_ERRORS } from "../actions/types";

const initialState = {
  msg: null,
  status: null,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_ERRORS:
      return {
        ...state,
        msg: action.payload.msg,
        status: action.payload.status,
      };
    case CLEAR_ERROR:
      return {
        ...state,
        msg: null,
        status: null,
      };
    default:
      return state;
  }
}
